import {useEffect, useState} from 'react';

import {useDispatch, useSelector} from 'react-redux';

import {getOnePageUpsellData} from 'desktop/pages/success/store/reducers/order/order';
import {getOrderState} from 'desktop/pages/success/store/selectors/selectors';
import {AppThunkDispatchType} from 'desktop/store';
import {getUrlParams} from 'libs/url/url';

/**
 * Use get TYP Data
 */
export const useGetTYPData = () => {
    const [shouldRedirect, setShouldRedirect] = useState<boolean>(false);
    const dispatch = useDispatch<AppThunkDispatchType>();
    const {status} = useSelector(getOrderState);

    useEffect(() => {
        const {id} = getUrlParams();
        dispatch(
            getOnePageUpsellData({
                orderId: (id && id[0]) || '',
            }),
        );
    }, [dispatch]);

    useEffect(() => {
        if (status === 'rejected') {
            setShouldRedirect(true);
        }
    }, [status]);

    return shouldRedirect;
};
